<template>
  <div>
    <div
      class="c-textarea"
      :class="{
        'c-textarea--with-floating-label': floatingLabel,
        'c-textarea--active-floating-label': value && floatingLabel,
        'c-textarea--invalid': invalid,
        'c-textarea--focused': focused,
      }"
    >
      <div v-if="label" class="c-textarea__label">
        {{ label }}
      </div>

      <div v-if="floatingLabel" class="c-textarea__floating-label--hidden">{{ floatingLabel }}</div>

      <div class="c-textarea__wrapper">
        <textarea
          ref="field"
          v-model="textValue"
          class="c-textarea__field"
          rows="1"
          :maxlength="maxLength"
          :placeholder="placeholder"
          @focus="focused = true"
          @focusout="focused = false"
        >
        </textarea>

        <div v-if="floatingLabel" class="c-textarea__floating-label">
          {{ floatingLabel }}
        </div>

        <div class="c-textarea__actions">
          <div
            v-if="clearable"
            class="c-textarea__action c-textarea__clear"
            :class="{ 'c-textarea__clear--active': textValue }"
            @click="clear"
          >
            <svg-icon name="times" size="md" color="secondary"></svg-icon>
          </div>
        </div>
      </div>

      <div class="c-textarea__border"></div>
    </div>
  </div>
</template>

<script>
import SvgIcon from "@/components/svg-icon";

export default {
  name: "c-textarea",

  components: {
    "svg-icon": SvgIcon,
  },

  props: ["value", "label", "floatingLabel", "invalid", "placeholder", "clearable", "maxLength"],

  data() {
    return {
      focused: false,
      textValue: "",
    };
  },

  watch: {
    value(v) {
      this.textValue = v;
    },
    textValue(value) {
      this.$nextTick(() => {
        const { field } = this.$refs;
        field.style.height = "auto";
        const newHeight = field.scrollHeight;
        // field.style.height = `${newHeight}px`;
      });
      this.$emit("input", value);
    },
  },

  created() {
    this.textValue = this.value;
  },

  methods: {
    clear() {
      this.textValue = "";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.c-textarea {
  position: relative;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: flex-start;

  textarea {
     &::placeholder {
      color: $color-label;
    }
  }

  &__field {
    position: relative;
    width: 100%;
    padding: 0 0 13px 0;
    font-size: 15px;
    line-height: 108%;
    box-sizing: border-box;
    //max-height: 200px;
    height: 30px;
    overflow-y: hidden;
    border: none;
    resize: none;

    @media screen and (max-height: 700px) {
      //max-height: 100px;
    }

    &:focus {
      outline: none;

      & + .c-textarea__floating-label {
        font-size: 13px;
        transform: translate3d(0, -100%, 0);
      }
    }
  }

  &--active-floating-label {
    .c-textarea__floating-label {
      font-size: 13px;
      transform: translate3d(0, -100%, 0);
    }
  }

  &__label {
    font-size: 12px;
    line-height: 13px;
    margin-bottom: 10px;
    color: $color-label;
  }

  &__floating-label {
    position: absolute;
    overflow: hidden !important;
    max-width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    left: 0;
    font: 400 15px Fira Sans;
    pointer-events: none;
    line-height: 18px;
    color: $color-label;
    padding-bottom: 10px;
    transition: all 200ms;

    &--hidden {
      visibility: hidden;
      font-size: 12px;
      margin-bottom: 10px;
    }
  }

  &__wrapper {
    width: 100%;
    display: flex;
  }

  &__actions {
    display: flex;
    order: 3;
    align-items: flex-start;
  }

  &__action {
    margin-left: 10px;
  }

  &__clear {
    margin-top: 5px;
    transition: 0.2s;
    opacity: 0;
    visibility: hidden;
    cursor: pointer;

    &--active {
      opacity: 1;
      visibility: visible;
    }
  }

  &__border {
    height: 1px;
    width: 100%;
    position: absolute;
    background: $color-control-border;
    bottom: 0;
    transition: 0.2s;
  }

  &--focused {
    .c-textarea__border {
      background: $color-primary;
    }
  }

  &--invalid {
    .c-textarea__border {
      background: $color-pink;
    }
  }
}
</style>
